import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Col, Form, Input, message, Modal, Row, Select, Switch } from "antd";

import { justificationsService } from "../../redux/services";

import {
	UIDrawerForm,
	UIFormSection,
	UIInfoBanner,
	UISwitchField,
} from "./../../components";

const formId = `form-drawer-${Math.floor(Math.random() * 10001)}`;

export const JUSTIFICATION_TYPES = {
	abono_horas                  : "Abono de horas",
	descontar_horas_falta        : "Descontar horas falta",
	descontar_horas_falta_sem_dsr: "Descontar horas falta sem descontar DSR",
	descontar_banco_horas        : "Descontar do banco de horas",
	sem_jornada                  : "Dia sem horário",
	ajuste                       : "Ajuste",
};

export const JustificationStatusField = () => (
	<Form.Item label="Status" required>
		<UISwitchField
			bordered
			title="Ativo"
			description="Justificativas inativas não aparecem para seleção ao ajustar o ponto.">
			<Form.Item name="ativo" valuePropName="checked" noStyle>
				<Switch />
			</Form.Item>
		</UISwitchField>
	</Form.Item>
);

export const JustificationsInfoBanner = () => (
	<UIInfoBanner
		icon={<i className="fal fa-info-circle" />}
		title="Sobre justificativas"
		description="O tipo define o efeito da justificativa no cálculo: abono de horas, desconto de falta, desconto no banco de horas, dia sem horário ou ajuste."
	/>
);

class Create extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			isSending: false,
		};
	}

	onOpen = () => {
		setTimeout(() => {
			this.nome && this.nome.focus();
		}, 100);
	};

	onClose = () => {
		// Callback
		this.props.onClose();
	};

	onFinish = (values) => {
		this.setState({
			isSending: true,
		});

		justificationsService.create(values)
			.then((response) => {
				this.setState({
					isSending: false,
				});

				// Success message
				message.success("Justificativa cadastrada com sucesso.");

				// Callback
				this.props.onComplete();
			})
			.catch((data) => {
				this.setState({
					isSending: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	render() {
		const { visible } = this.props;

		const { isLoading, isSending } = this.state;

		return (
			<UIDrawerForm
				visible={visible}
				width={700}
				onClose={this.onClose}
				isLoading={isLoading}
				isSending={isSending}
				formId={formId}
				icon={<i className="fal fa-file-alt" />}
				title="Incluir nova justificativa"
				subtitle="Cadastre um novo tipo de justificativa."
				btnSaveText="Salvar justificativa">
				<Form
					ref={el => this.form = el}
					id={formId}
					layout="vertical"
					scrollToFirstError
					onFinish={this.onFinish}
					initialValues={{
						ativo: true,
					}}>
					<UIFormSection
						icon={<i className="fal fa-clipboard-list" />}
						title="Informações gerais"
						description="Nome e efeito da justificativa no ponto.">
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<Form.Item name="nome" label="Nome" hasFeedback rules={[{ required: true, message: "Campo obrigatório." }]}>
									<Input ref={el => this.nome = el} placeholder="Digite o nome da justificativa" />
								</Form.Item>
							</Col>
							<Col xs={24} md={12}>
								<Form.Item name="acao" label="Tipo" rules={[{ required: true, message: "Campo obrigatório." }]}>
									<Select
										optionFilterProp="children"
										filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
										allowClear
										placeholder="Selecione o tipo de justificativa"
										showSearch>
										{Object.entries(JUSTIFICATION_TYPES).map(([value, label]) => (
											<Select.Option key={value} value={value}>{label}</Select.Option>
										))}
									</Select>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<JustificationStatusField />
							</Col>
						</Row>
					</UIFormSection>
					<JustificationsInfoBanner />
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Create;
